module.exports = __webpack_public_path__ + "media/Icons/horizontal_pic_advice-5bef64fb.svg";